import { Link } from 'react-router-dom';
import { Flame, Facebook, MessageCircle } from 'lucide-react';
import { SITE_NAME, SITE_TAGLINE, WHATSAPP_NUMBER } from '../lib/brand';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-x1493-dark text-white/70 py-12 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo.png" alt={SITE_NAME} className="h-10 w-auto" />
              <span className="text-xl font-bold text-white">{SITE_NAME}</span>
            </div>
            <p className="text-sm leading-relaxed">
              {SITE_TAGLINE}
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">探索</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-x1493-secondary transition">首頁</Link></li>
              <li><Link to="/story" className="hover:text-x1493-secondary transition">品牌故事</Link></li>
              <li><Link to="/media-coverage" className="hover:text-x1493-secondary transition">媒體報道</Link></li>
              <li><Link to="/offers" className="hover:text-x1493-secondary transition">食肆優惠</Link></li>
              <li><Link to="/store" className="hover:text-x1493-secondary transition">商店</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">合作專區</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/merchant/submit-offer" className="hover:text-x1493-secondary transition">商家提交優惠</Link></li>
              <li><Link to="/merchant/center" className="hover:text-x1493-secondary transition">商家中心登入</Link></li>
              <li><Link to="/supplier/portal" className="hover:text-x1493-secondary transition">供貨商門戶</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">聯繫我們</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <MessageCircle size={16} className="text-x1493-secondary" />
                <a href={`https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" className="hover:text-x1493-secondary transition">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Facebook size={16} className="text-x1493-secondary" />
                <a
                  href="https://www.facebook.com/groups/2637062093216141"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-x1493-secondary transition"
                >
                  Facebook Group
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>© {currentYear} {SITE_NAME}</p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-x1493-secondary transition">條款及細則</Link>
            <span className="text-white/30">|</span>
            <Link to="/privacy" className="hover:text-x1493-secondary transition">隱私條款</Link>
          </div>
          <p>
            Powered by{' '}
            <a
              href="https://jkdcoding.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-yellow-300 hover:underline"
            >
              JKDCoding
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
